

interface QuotationActionsProps {
  onDownloadPDF: () => void;
  onUpdateStatus: () => void;
  onConvertToEvent: () => void;
  onEdit: () => void;
  onBack: () => void;
  isStaff?: boolean;
}

export default function QuotationActions({
  onDownloadPDF,
  onUpdateStatus,
  onConvertToEvent,
  onEdit,
  onBack,
  isStaff = false,
}: QuotationActionsProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <h2 className="text-lg font-semibold text-stone-800">Actions</h2>
      </div>
      <div className="p-6">
        <div className="flex flex-wrap gap-3">
          <button
            onClick={onEdit}
            className="px-4 py-2 bg-stone-600 text-white rounded-lg hover:bg-stone-700 transition-colors"
          >
            Edit
          </button>
          <button
            onClick={onDownloadPDF}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Download PDF
          </button>
          <button
            onClick={onUpdateStatus}
            className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
          >
            Update Status
          </button>
          {!isStaff && (
            <button
              onClick={onConvertToEvent}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              Convert to Event
            </button>
          )}
          <button
            onClick={onBack}
            className="px-4 py-2 rounded-lg border border-stone-200 text-stone-700 hover:bg-stone-100 transition-colors"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
